import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import classNames from "classnames";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";

const SendButton: FC<Props> = ({
  className = "",
  text,
  onClick,
  handleError = () => {},
  disabled = false,
  bgColor,
}) => {
  return (
    <div
      onClick={() => {
        if (disabled) {
          handleError();
          return;
        }
        onClick();
      }}
      className={classNames(
        styles.button,
        disabled && styles.disabled,
        className,
      )}
      style={{ background: bgColor }}
    >
      <SendOutlinedIcon></SendOutlinedIcon>
      {text}
    </div>
  );
};

export default SendButton;
